import { getConfig } from "~/org/twilio/one-support-center/shared/osc-env";

const { consoleEndpoint } = getConfig();

const constants = {
  submitTicketPage: `submit`,
  loginPage: consoleEndpoint,
};

export default constants;
